'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _epsilon = require('babel-runtime/core-js/number/epsilon');

var _epsilon2 = _interopRequireDefault(_epsilon);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _dec2, _class2, _dec3, _class3, _dec4, _class4, _dec5, _class5, _dec6, _class6, _dec7, _class7, _dec8, _class8, _dec9, _dec10, _class9, _class10, _temp; // chain


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _lodash = require('lodash');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _components = require('../../components');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./Family.css');

/**
 * <FamilyResults 
 *   fundFamily
 * />
 * 
 * Displays results for major fund families. Includes a chart, category
 * breakdowns, tweet button, and stats on ESG and fossil-free funds. Category
 * breakdowns are rendered by <FamilyResultsSectorDetails />.
 * 
 */
var FamilyResults = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(FamilyResults, _Component);

  function FamilyResults(props) {
    (0, _classCallCheck3.default)(this, FamilyResults);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FamilyResults.__proto__ || (0, _getPrototypeOf2.default)(FamilyResults)).call(this, props));

    _this.state = {
      fundFamily: props.fundFamily || null
    };
    return _this;
  }

  (0, _createClass3.default)(FamilyResults, [{
    key: 'render',
    value: function render() {
      var fundFamily = this.state.fundFamily;

      if (!fundFamily) {
        return null;
      }

      var sriGreen = fundFamily.sri > 0 ? 'green' : 'black';
      var safeName = encodeURIComponent(fundFamily.name);
      var urlBase = _config2.default.routes.list + '?ff=' + safeName;
      var sriUrl = urlBase + '&sri=1&srt=gef_score';

      var gef_score_norm = fundFamily.gef_score_norm,
          gef_score = fundFamily.gef_score;


      var overallScoreIcon = require('../../../static/images/GEF-icons-gender-equality-score.svg');

      var tip = 'To calculate an average gender equality score for major fund\n      managers, we:\n      <ul style=\'padding-inline-start: 1px !important;\'>\n        <li>\n          take each fund that\'s been scored by Gender Equality Funds\n        </li>\n        <li>\n          average the overall gender equality scores, weighted by fund assets\n          (so larger funds count more)\n        </li>\n      </ul>\n      Below we\'ve ranked the nine fund managers with the most assets scored by\n      Gender Equality Funds by average overall gender equality score.';
      tip = _format2.default.tooltipHtml(tip);

      return _react2.default.createElement(
        'div',
        { styleName: 'overall-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'overall-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'overall-score-container' },
            _react2.default.createElement(
              'div',
              {
                styleName: 'overall-score-container-inner',
                'data-multiline': true,
                'data-effect': 'solid',
                'data-place': 'bottom',
                'data-for': 'family-score-container',
                'data-html': true,
                'data-event': 'click focus',
                ref: 'familyScoreContainer',
                'data-tip': tip
              },
              _react2.default.createElement(
                'div',
                { styleName: 'overall-score-title' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'icon-label-wrap' },
                  _react2.default.createElement('img', {
                    src: overallScoreIcon,
                    alt: 'Average gender equality score',
                    styleName: 'inline-icon'
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-label' },
                    'Average gender equality score'
                  )
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'div',
                { styleName: 'overall-score-chart-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'overall-score-chart' },
                  _react2.default.createElement(_components.Chart, {
                    gefScore: Math.round(gef_score_norm).toFixed(0),
                    gefStyle: _format2.default.scoreStyle(Math.round(gef_score_norm).toFixed(0)),
                    type: 'large'
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'overall-score-text' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'overall-score-headline' },
                    'Average overall score'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'overall-score-description' },
                    'Weighted average of fund Overall Gender Scores'
                  )
                )
              )
            ),
            _react2.default.createElement(_reactTooltip2.default, {
              id: 'family-score-container',
              globalEventOff: 'click'
              // afterShow={ () => { this.closeAllTooltipsExcept('familyScoreContainer') } }
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'overall-sri-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'overall-sri-container-inner' },
              _react2.default.createElement(FamilyStatCount, {
                tip: _format2.default.tooltipHtml('Number of funds analyzed and scored from this family.'),
                count: _format2.default.number(fundFamily.gef_num_funds),
                label: 'funds scored'
              }),
              _react2.default.createElement(_reactTooltip2.default, { id: 'flaggedfund-tooltip' })
            ),
            _react2.default.createElement(_reactTooltip2.default, { id: 'sri-container' })
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'chart-content-hl-wrap' },
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle', nospace: true }),
            '\xA0 This data covers open-end mutual funds and exchange-traded funds domiciled in the U.S. with at least 50% of assets invested in stocks. It excludes bond funds, as well as closed-end funds, collective trusts, and funds domiciled outside the U.S.'
          )
        ),
        _react2.default.createElement(FamilyRankingsList, { fundFamily: fundFamily })
      );
    }
  }]);
  return FamilyResults;
}(_react.Component)) || _class);

/**
 * <FamilyStatCount
 *   fundFamily
 * />
 * 
 */

var FamilyStatCount = (_dec2 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec2(_class2 = function (_Component2) {
  (0, _inherits3.default)(FamilyStatCount, _Component2);

  function FamilyStatCount(props) {
    (0, _classCallCheck3.default)(this, FamilyStatCount);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (FamilyStatCount.__proto__ || (0, _getPrototypeOf2.default)(FamilyStatCount)).call(this, props));

    _this2.state = {
      tip: props.tip || null,
      count: props.count || null,
      label: props.label || null
    };
    return _this2;
  }

  (0, _createClass3.default)(FamilyStatCount, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          tip = _state.tip,
          count = _state.count,
          label = _state.label;

      if (!tip || !label) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        {
          styleName: 'stat',
          'data-multiline': true,
          'data-effect': 'solid',
          'data-tip': tip,
          'data-html': true,
          'data-place': 'bottom',
          'data-for': 'flaggedfund-tooltip'
        },
        _react2.default.createElement(
          'div',
          { styleName: 'stat-count' },
          count
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'stat-label' },
          label
        )
      );
    }
  }]);
  return FamilyStatCount;
}(_react.Component)) || _class2);

/**
 * <FamilyRankingsList
 *   fundFamily
 *   fundFamilyList
 * />
 * 
 */

var FamilyRankingsList = (_dec3 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec3(_class3 = function (_Component3) {
  (0, _inherits3.default)(FamilyRankingsList, _Component3);

  function FamilyRankingsList(props) {
    (0, _classCallCheck3.default)(this, FamilyRankingsList);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (FamilyRankingsList.__proto__ || (0, _getPrototypeOf2.default)(FamilyRankingsList)).call(this, props));

    _this3.state = {
      fundFamily: props.fundFamily || null
    };
    return _this3;
  }

  (0, _createClass3.default)(FamilyRankingsList, [{
    key: 'render',
    value: function render() {
      var fundFamily = this.state.fundFamily;

      if (!fundFamily) {
        return null;
      }

      var fundFamilyList = _config2.default.familyFunds;

      var sorted = (0, _lodash.orderBy)(fundFamilyList, ['gef_score_norm'], ['desc']);
      var activeArrow = require('../../../static/images/active-arrow.svg');

      return _react2.default.createElement(
        'div',
        { styleName: 'family-ul-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'family-ul-headline' },
          'Scoring major fund managers'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'family-ul-lede' },
          'See the average gender equality scores for the largest asset managers in our database.'
        ),
        _react2.default.createElement(
          'ul',
          { styleName: 'family-ul' },
          _react2.default.createElement(
            'li',
            { styleName: 'family-li-head' },
            _react2.default.createElement(
              'div',
              { styleName: 'family-li-name-head' },
              'Fund manager'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'family-li-score-head' },
              'Avg. fund score'
            )
          ),
          sorted.map(function (item, idx) {
            return _react2.default.createElement(
              'li',
              { key: idx },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.families + '?q=' + item.name,
                  title: item.name
                },
                _react2.default.createElement(
                  'div',
                  {
                    styleName: item.name === fundFamily.name ? 'family-li active' : 'family-li'
                  },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'family-li-name' },
                    item.name === fundFamily.name ? _react2.default.createElement(
                      'span',
                      null,
                      _react2.default.createElement('img', {
                        src: activeArrow,
                        alt: fundFamily.name,
                        styleName: 'arrow'
                      }),
                      '\xA0'
                    ) : null,
                    item.name
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'family-li-score' },
                    Math.round((item.gef_score_norm + _epsilon2.default) * 10) / 10,
                    '\xA0',
                    _react2.default.createElement(
                      'span',
                      { styleName: 'family-li-score-light' },
                      '/ 100 points'
                    )
                  )
                )
              )
            );
          })
        )
      );
    }
  }]);
  return FamilyRankingsList;
}(_react.Component)) || _class3);

/**
 * <FamilyBanner
 *   fundFamily
 * />
 * 
 * Displays a banner for the fund family that has a different tagline if the
 * family is one of the 10 families with additional data in config, or just
 * a generic fund family.
 * 
 */

var FamilyBanner = (_dec4 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec4(_class4 = function (_Component4) {
  (0, _inherits3.default)(FamilyBanner, _Component4);

  function FamilyBanner(props) {
    (0, _classCallCheck3.default)(this, FamilyBanner);

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (FamilyBanner.__proto__ || (0, _getPrototypeOf2.default)(FamilyBanner)).call(this, props));

    _this4.state = {
      fundFamily: props.fundFamily || null
    };
    return _this4;
  }

  (0, _createClass3.default)(FamilyBanner, [{
    key: 'render',
    value: function render() {
      var fundFamily = this.state.fundFamily;

      if (!fundFamily) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'banner-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'banner' },
          _react2.default.createElement(
            'div',
            { styleName: 'banner-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'banner-taglines' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-tagline' },
                  fundFamily ? _react2.default.createElement(
                    'span',
                    null,
                    'Are your retirement funds'
                  ) : _react2.default.createElement(
                    'span',
                    null,
                    'Your retirement plan could'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-tagline' },
                  fundFamily ? _react2.default.createElement(
                    'span',
                    null,
                    'invested with ',
                    fundFamily.fund_family_label,
                    '?'
                  ) : _react2.default.createElement(
                    'span',
                    null,
                    'be funding gender inequality'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'toolkit' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'toolkit-info' },
                  'Check out our action toolkit and talk to your retirement plan manager'
                ),
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.toolkit,
                    log: _analytics2.default.eventToToolkit(),
                    title: 'Gender-lens investing action toolkit' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'toolkit-action' },
                    'Action toolkit',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return FamilyBanner;
}(_react.Component)) || _class4);

/**
 * <FamilySummarySentence
 *   fundFamily
 * />
 *
 * Displays sentence for the fund family that names the fund company
 * at the top of the list of funds and shareclasses for this family.
 *
 */

var FamilySummarySentence = (_dec5 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec5(_class5 = function (_Component5) {
  (0, _inherits3.default)(FamilySummarySentence, _Component5);

  function FamilySummarySentence(props) {
    (0, _classCallCheck3.default)(this, FamilySummarySentence);

    var _this5 = (0, _possibleConstructorReturn3.default)(this, (FamilySummarySentence.__proto__ || (0, _getPrototypeOf2.default)(FamilySummarySentence)).call(this, props));

    _this5.state = {
      fundFamily: props.fundFamily || null
    };
    return _this5;
  }

  (0, _createClass3.default)(FamilySummarySentence, [{
    key: 'render',
    value: function render() {
      var fundFamily = this.state.fundFamily;

      if (!fundFamily) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'summary' },
        fundFamily.fund_family_label,
        ' funds in our database'
      );
    }
  }]);
  return FamilySummarySentence;
}(_react.Component)) || _class5);

/**
 * <FamilyFundList
 *   fundList
 * />
 * 
 * Displays a list of funds for this family. Maps a fundList to a list of
 * FamilyFundListItem components.
 * 
 */

var FamilyFundList = (_dec6 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec6(_class6 = function (_Component6) {
  (0, _inherits3.default)(FamilyFundList, _Component6);

  function FamilyFundList(props) {
    (0, _classCallCheck3.default)(this, FamilyFundList);

    var _this6 = (0, _possibleConstructorReturn3.default)(this, (FamilyFundList.__proto__ || (0, _getPrototypeOf2.default)(FamilyFundList)).call(this, props));

    _this6.state = {
      fundList: props.fundList || null
    };
    return _this6;
  }

  (0, _createClass3.default)(FamilyFundList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.fundList) {
        this.setState({
          fundList: props.fundList
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var fundList = this.state.fundList;

      if (!fundList) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'holding-list' },
        fundList.map(function (fund, idx) {
          return _react2.default.createElement(FamilyFundListItem, {
            fund: fund,
            key: 'family-fund-list-item-' + idx
          });
        })
      );
    }
  }]);
  return FamilyFundList;
}(_react.Component)) || _class6);

/**
 * <FamilyFundListItem 
 *   fund
 * />
 * 
 * Displays a fund in the list of funds for this family. Displays some summary
 * stats. Displays a list of tickers using the FamilyFundListItemTickerLinks
 * component.
 * 
 */

var FamilyFundListItem = (_dec7 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec7(_class7 = function (_Component7) {
  (0, _inherits3.default)(FamilyFundListItem, _Component7);

  function FamilyFundListItem(props) {
    (0, _classCallCheck3.default)(this, FamilyFundListItem);

    var _this7 = (0, _possibleConstructorReturn3.default)(this, (FamilyFundListItem.__proto__ || (0, _getPrototypeOf2.default)(FamilyFundListItem)).call(this, props));

    _this7.state = {
      fund: props.fund || null
    };
    return _this7;
  }

  (0, _createClass3.default)(FamilyFundListItem, [{
    key: 'render',
    value: function render() {
      var fund = this.state.fund;

      if (!fund) {
        return null;
      }

      var fund_id = fund.fund_id,
          fund_legal_name = fund.fund_legal_name,
          currency = fund.currency,
          grade_gender_equality = fund.grade_gender_equality;


      var grp = fund.category_group;

      var grades = {
        gefOverallGroupGrade: _format2.default.gefGrade(_format2.default.gefScore(fund.gef_grp, _config2.default.gefScoreNormalizers.groups[grp], 0, 1, true))
      };

      var activeGradeAsInt = _format2.default.gefGradeAsInt(grades.gefOverallGroupGrade);

      return _react2.default.createElement(
        'div',
        { styleName: 'holding' },
        _react2.default.createElement(
          'div',
          { styleName: 'ticker-name-assets' },
          _react2.default.createElement(
            'div',
            { styleName: 'ticker-name' },
            _react2.default.createElement(
              'div',
              { styleName: 'holdings-name' },
              fund_legal_name
            ),
            _react2.default.createElement(FamilyFundListItemTickerLinks, { shareclasses: fund.shareclass })
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'score-wrapper' },
          'Score',
          _react2.default.createElement(_components.GenderEqualityScoreLabel, { fund: fund, gefType: 'gef_score' })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'score-wrapper' },
          'Group rank',
          _react2.default.createElement(
            'div',
            { styleName: 'col-center' },
            _react2.default.createElement(_components.GenderEqualityScoreLabel, { fund: fund, gefType: 'gef_grp' }),
            fund['gef_grp'] != -1.0 ? _react2.default.createElement(
              'div',
              { styleName: 'reportcard-result-grade' },
              _react2.default.createElement(_components.Grade, { grade: activeGradeAsInt })
            ) : null
          )
        )
      );
    }
  }]);
  return FamilyFundListItem;
}(_react.Component)) || _class7);

/**
 * <FamilyFundListItemTickerLinks 
 *   shareclasses
 * />
 * 
 * Displays a list of tickers, linked to those shareclass profiles, for a fund
 * in the fund list. Maps a list of shareclasses to a list of URLs and
 * tickers. Maps the list of URLs and tickers to a list of Links.
 * 
 */

var FamilyFundListItemTickerLinks = (_dec8 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec8(_class8 = function (_Component8) {
  (0, _inherits3.default)(FamilyFundListItemTickerLinks, _Component8);

  function FamilyFundListItemTickerLinks(props) {
    (0, _classCallCheck3.default)(this, FamilyFundListItemTickerLinks);

    var _this8 = (0, _possibleConstructorReturn3.default)(this, (FamilyFundListItemTickerLinks.__proto__ || (0, _getPrototypeOf2.default)(FamilyFundListItemTickerLinks)).call(this, props));

    _this8.state = {
      shareclasses: props.shareclasses || null
    };
    return _this8;
  }

  (0, _createClass3.default)(FamilyFundListItemTickerLinks, [{
    key: 'render',
    value: function render() {
      var shareclasses = this.state.shareclasses;

      if (!shareclasses) {
        return null;
      }

      var tickerUrls = shareclasses.map(function (e, i) {
        var tckr = e.ticker || 'N/A';
        var safeTicker = e.ticker || 'N';
        var url = _config2.default.routes.fund + '/' + _format2.default.sanitize(e.fund_legal_name) + '/' + safeTicker + '/' + _config2.default.profilePath + '/' + e.fund_id + '/' + e.investment_vehicle_id;

        return {
          ticker: tckr,
          name: e.name,
          url: url
        };
      });

      if (tickerUrls.length === 1 && tickerUrls[0].ticker === 'N/A') {
        var e = tickerUrls[0];
        return _react2.default.createElement(
          'div',
          { styleName: 'ticker-links' },
          _react2.default.createElement(
            _components.Link,
            { to: e.url, title: e.name },
            _react2.default.createElement(
              'span',
              { styleName: 'ticker' },
              'See results',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'ticker-links' },
        tickerUrls.map(function (e, i) {
          return _react2.default.createElement(
            _components.Link,
            {
              key: 'holding-link-' + i,
              to: e.url,
              title: e.name
            },
            e.ticker === 'N/A' ? _react2.default.createElement(
              'span',
              { styleName: 'ticker' },
              e.name
            ) : _react2.default.createElement(
              'span',
              { styleName: 'ticker' },
              e.ticker
            )
          );
        })
      );
    }
  }]);
  return FamilyFundListItemTickerLinks;
}(_react.Component)) || _class8);
var Family = (_dec9 = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.familyShareClass.result,
    searching: state.familyShareClass.loading,
    searched: state.familyShareClass.loaded,
    error: state.familyShareClass.error,
    sector: state.sector.result
  };
}, searchActions), _dec10 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec9(_class9 = _dec10(_class9 = (_temp = _class10 = function (_Component9) {
  (0, _inherits3.default)(Family, _Component9);

  function Family(props) {
    (0, _classCallCheck3.default)(this, Family);

    var _this9 = (0, _possibleConstructorReturn3.default)(this, (Family.__proto__ || (0, _getPrototypeOf2.default)(Family)).call(this, props));

    _this9.getMoreFunds = function () {
      _this9.familyShareClasses(_this9.state.family, _this9.state.page + 1);
    };

    _this9.familyShareClasses = function (family, page) {
      page = page || _this9.state.page;
      _this9.setState({ page: page });
      _this9.props.familyShareClasses(family, page);
    };

    _this9.configFundFamily = function () {
      return _config2.default.familyFunds.find(function (family) {
        return family.name === _this9.state.family;
      });
    };

    _this9.configEngagementFamily = function () {
      return _config2.default.engagementFunds.find(function (family) {
        return family.name === _this9.state.family;
      });
    };

    _this9.state = {
      page: 1,
      family: props.location.query.q || '',
      searchQuery: '',
      lastResult: null,
      funds: []
    };
    return _this9;
  }

  (0, _createClass3.default)(Family, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
      this.familyShareClasses(this.state.family, 1);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var q = props.location.query.q || '';
      if (q !== this.state.family) {
        this.familyShareClasses(q, 1);
        window.scroll(0, 0);
        this.setState({
          page: 1,
          family: q,
          searchQuery: '',
          lastResult: null,
          funds: []
        });
      } else if (props.result && this.state.lastResult !== props.result) {
        this.setState({
          lastResult: props.result,
          funds: this.state.funds.concat(props.result)
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!(this.state.page !== 1 || !this.props.searching)) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, { options: { scale: 0.70, top: '2.0rem' }, loaded: false })
        );
      }

      if (!this.props.location.query.q) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_components.FamilyGrid, { fullGrid: true })
        );
      }

      var funds = this.state.funds;


      var fundFamily = this.configFundFamily();

      var fileName = _format2.default.imgPath(this.state.family);
      var hasLogo = false;
      var companyLogo = null;
      try {
        companyLogo = require('../../../static/images/fam/' + fileName + '.png');
        hasLogo = true;
      } catch (e) {
        console.log('');
      }

      var hasMore = this.state.lastResult && this.state.lastResult.length === _config2.default.queryMaxFunds;

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _container2.default.helmet(this.state.family || 'Major asset managers'),
        _react2.default.createElement(
          _reactLoader2.default,
          {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: this.state.page !== 1 || !this.props.searching
          },
          _react2.default.createElement(
            'div',
            { styleName: 'snapshot-wrapper' },
            _react2.default.createElement(
              'div',
              { styleName: 'snapshot' },
              _react2.default.createElement(
                'div',
                { styleName: 'name-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'name' },
                  _react2.default.createElement(
                    'div',
                    { styleName: fundFamily ? 'name-tag-big' : 'name-tag' },
                    fundFamily ? 'Major fund manager' : 'Fund manager'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  fundFamily ? _react2.default.createElement(_components.SocialButtons, {
                    message: _config2.default.app.title + ' - ' + fundFamily.name,
                    link: _config2.default.routes.families + '?q=' + this.state.family
                  }) : null
                )
              ),
              hasLogo ? _react2.default.createElement(
                'div',
                { styleName: 'name-logo' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'name-logo-lbl' },
                  fundFamily ? fundFamily.label : this.state.family
                ),
                _react2.default.createElement('img', {
                  styleName: 'name-logo-img',
                  src: companyLogo,
                  alt: fundFamily ? fundFamily.label : this.state.family
                })
              ) : _react2.default.createElement(
                'span',
                null,
                this.state.family
              ),
              _react2.default.createElement(FamilyResults, { fundFamily: fundFamily })
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'holdings-wrapper' },
            _react2.default.createElement(
              'div',
              { styleName: 'holdings' },
              _react2.default.createElement(FamilySummarySentence, { fundFamily: fundFamily }),
              _react2.default.createElement(
                'div',
                { styleName: 'holdings-inner' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'rating-label' },
                  _react2.default.createElement('div', { styleName: 'rating-label-line' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'rating-label-info' },
                    'Gender equality score'
                  )
                ),
                _react2.default.createElement(FamilyFundList, { fundList: funds })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'more-funds-wrapper' },
            _react2.default.createElement(_reactLoader2.default, {
              options: { scale: 0.70, top: '0' },
              loaded: !this.props.searching
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'more-funds' },
              _react2.default.createElement(
                'div',
                {
                  onClick: hasMore ? this.getMoreFunds : null,
                  styleName: hasMore ? 'more-funds-button' : 'no-more-funds-button'
                },
                hasMore ? 'Get more funds' : 'No more funds',
                _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-plus-circle' })
              ),
              !hasMore ? _react2.default.createElement(
                'div',
                { styleName: 'no-more-funds-info' },
                'Looking for your favorite fund and can\'t find it? Sorry, but we don\'t have everything in our database.'
              ) : null
            )
          ),
          _react2.default.createElement(_components.GetStartedInput, null),
          _react2.default.createElement(FamilyBanner, { fundFamily: fundFamily })
        )
      );
    }
  }]);
  return Family;
}(_react.Component), _class10.propTypes = {
  searching: _react.PropTypes.bool,
  searched: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.array
}, _temp)) || _class9) || _class9);
exports.default = Family;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Family/Family.js
// module id = 1303
// module chunks = 0